import React, { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

import { ORDEM_TIPOS, TIPOS_CLIENTE } from "./tipos";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token") || ""}` } });
const qtd = (n) => Number(n || 0).toLocaleString("pt-BR");

/** Quantos clientes a loja tem hoje em cada tipo (os números dos cards de Clientes). */
export function useContagemTipos() {
  const [contagens, setContagens] = useState(null);
  useEffect(() => {
    let vivo = true;
    axios.get("/api/clientes/pagina?pagina=1&por_pagina=1", auth())
      .then((r) => { if (vivo) setContagens(r.data?.contagens || {}); })
      .catch(() => { if (vivo) setContagens({}); });
    return () => { vivo = false; };
  }, []);
  return contagens;
}

function Pilula({ ativo, onClick, children, e2e, titulo }) {
  return (
    <button type="button" onClick={onClick} title={titulo} aria-pressed={ativo} data-e2e={e2e}
      className={`h-8 px-3 rounded-full border text-xs font-semibold transition-colors ${
        ativo ? "border-primary bg-primary/10 text-primary" : "border-border text-muted-foreground hover:bg-muted"}`}>
      {children}
    </button>
  );
}

/**
 * "Para quem vale" (dono, 27/10/2026): pílulas com os tipos de cliente da tela
 * de Clientes e quantos clientes há em cada um. `valor` = tipos marcados
 * (vazio = todos). `ajuda` explica a regra de cada oferta.
 */
export default function ParaQuemVale({ valor, aoMudar, titulo = "Para quem vale", ajuda, e2e = "para-quem-vale", desabilitado = false }) {
  const contagens = useContagemTipos();
  const marcados = valor || [];
  const alternar = (k) => aoMudar(marcados.includes(k) ? marcados.filter((x) => x !== k) : ORDEM_TIPOS.filter((x) => x === k || marcados.includes(x)));
  const total = contagens ? ORDEM_TIPOS.reduce((s, k) => s + Number(contagens[k] || 0), 0) : null;
  const noGrupo = contagens ? marcados.reduce((s, k) => s + Number(contagens[k] || 0), 0) : null;
  return (
    <div data-e2e={e2e} className={desabilitado ? "opacity-50 pointer-events-none" : ""}>
      <p className="text-sm font-semibold flex items-center gap-1.5"><Users className="w-4 h-4 text-primary" />{titulo}</p>
      {ajuda && <p className="text-xs text-muted-foreground mt-0.5">{ajuda}</p>}
      <div className="flex flex-wrap gap-1.5 mt-2">
        <Pilula ativo={!marcados.length} onClick={() => aoMudar([])} e2e={`${e2e}-todos`}>
          Todos os clientes{total != null && <span className="ml-1 opacity-70 tabular-nums">{qtd(total)}</span>}
        </Pilula>
        {ORDEM_TIPOS.map((k) => (
          <Pilula key={k} ativo={marcados.includes(k)} onClick={() => alternar(k)} titulo={TIPOS_CLIENTE[k].regra} e2e={`${e2e}-${k}`}>
            {TIPOS_CLIENTE[k].nome}{contagens && <span className="ml-1 opacity-70 tabular-nums">{qtd(contagens[k])}</span>}
          </Pilula>
        ))}
      </div>
      {!!marcados.length && (
        <p className="text-xs text-muted-foreground mt-2">
          {noGrupo != null && <><b className="text-foreground">{qtd(noGrupo)} clientes</b> hoje nesses tipos · </>}
          {marcados.map((k) => `${TIPOS_CLIENTE[k].nome}: ${TIPOS_CLIENTE[k].regra}`).join(" · ")}.
          {" "}O tipo é conferido na hora do pedido; o cliente precisa estar identificado.
        </p>
      )}
    </div>
  );
}
